"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ = require("../..");

var _mobxReact = require("mobx-react");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const ProgressiveStepper = (0, _mobxReact.observer)(({
  children,
  currentStep,
  delayBetween = 0,
  animate
}) => {
  return _react.default.createElement(_react.default.Fragment, null, _react.Children.map(children, (child, index) => {
    if (index < currentStep) {
      if (delayBetween || animate) {
        return _react.default.createElement(_.Delay, {
          waitBeforeShow: delayBetween
        }, _react.default.createElement(_.Expandable, {
          expand: true,
          restOnExpansion: true
        }, child));
      }

      return _react.default.createElement(_react.Fragment, {
        key: index
      }, child);
    }
  }));
});
var _default = ProgressiveStepper;
exports.default = _default;